import { Inventory, InventoryTransfer, User } from '@hefe/models';
import { userHasRole } from '../user/user.utils';

export const ActionType = {
  DELETE: 'delete',
  REQUEST_RETURN: 'request_return',
  CONFIRM_RETURN: 'confirm_return',
  CREATE_SHARE_LINK: 'create_share_link',
  SHOW_SHARE_LINK: 'show_share_link',
  NONE: 'none',
};

export const inventoryTransferActionTypes = (
  inventory: Inventory,
  transfer: InventoryTransfer,
  user?: User
) => {
  const types = [];

  if (transfer.is_return && !transfer.transferred_at) {
    types.push(ActionType.CONFIRM_RETURN);
  }

  const latestTransferredAtTransfer = inventory?.transfers
    ?.filter((t) => !!t.transferred_at)
    .sort(
      (a, b) =>
        new Date(b.transferred_at ?? '').getTime() -
        new Date(a.transferred_at ?? '').getTime()
    )[0];
  if (
    !inventory.has_active_transfer &&
    transfer.id === latestTransferredAtTransfer?.id &&
    transfer.to_user_id !== null // Only the last transfer which is not into the pool can request a return
  ) {
    types.push(ActionType.REQUEST_RETURN);
  }

  if (!transfer.transferred_at) {
    types.push(ActionType.DELETE);
  }

  if (
    !inventory.has_active_transfer &&
    transfer.id === latestTransferredAtTransfer?.id &&
    transfer.to_user_id === user?.id
  ) {
    types.push(ActionType.CREATE_SHARE_LINK);
  }

  if (
    !transfer.transferred_at &&
    (transfer.from_user_id === user?.id ||
      userHasRole(['superuser', 'admin', 'bb_admin'], user)) &&
    transfer.share_transfer_id
  ) {
    types.push(ActionType.SHOW_SHARE_LINK);
  }

  return types;
};
